import styled from 'styled-components';

const Container = styled.div`
  margin-top: 80px;
  padding: 20px;
`;

export { Container };
